export const category = [
  {
    title: "Product Design",
    src:"https://picsum.photos/800/400?random=1",
    alt:"Product Design Projects"
  },
  {
    title: "Architectural Design",
    src:"https://picsum.photos/800/400?random=2",
    alt:"Architectural Design Projects"
  },
  {
    title: "Hobbies",
    src:"https://picsum.photos/800/400?random=3",
    alt:"Hobbies"
  },
]


export const product = [
  {
    title: "School Website",
    subtitle: "Aromdi Music and Arts",
    description:
      "Website design and development of a creative learning school Website design and development of a creative learning schoolWebsite design and development of a creative learning schoolWebsite design and development of a creative learning school Website design and development of a creative learning school",
    src:
      "https://i.pinimg.com/564x/ca/ea/13/caea131a399fc37c4429895fae91bb76.jpg",
    link: "https://www.aromdi.com",
  },
  {
    title: "Restaurant Website",
    subtitle: "Brown Rice Thai Buffet",
    description:
      " Website design and development of a Thai restaurant in London,UKWebsite design and development of a Thai restaurant in London,UKWebsite design and development of a Thai restaurant in London,UKWebsite design and development of a Thai restaurant in London,UKWebsite design and development of aK",
    src:
      "https://i.pinimg.com/564x/d4/b6/3d/d4b63d134cab5c85dbd8d8b58526a35e.jpg",
    link: "https://Brownrice-uk.com",
  },
  {
    title: "Cosmetic Clinic",
    subtitle: "CDC London",
    description:
      "Branding and Corporate Identity design for a cosmetic clinic Branding and Corporate Identity design for a cosmetic clinic Branding and Corporate Identity design for a cosmetic clinic Branding and Corporate Identity design for a cosmetic clinic Branding and Corporate Identity design for a cosmetic clinic Branding and Corporate Identity design for a cosmetic clinic  ",
    src:
      "https://i.pinimg.com/564x/1e/91/e5/1e91e545bb553b270cc147815b048654.jpg",
    link: "https://reactbootcamp.com",
  },
  {
    title: "Habit Tracker Application",
    subtitle: "100daysofthings",
    description:
      "A Habit Tracker application that records your progress of what you are trying to complete consistently in a consecutive hundred days. A Habit Tracker application that records your progress of what you are trying to complete consistently in a consecutive hundred days.A Habit Tracker application that records your progress of what you are trying to complete consistently in a consecutive hundred days.",
    src:
      "https://i.pinimg.com/564x/44/dc/97/44dc97a90edf07cdf2a8282d53f44c00.jpg",
    link: "https://reactbootcamp.com",
  },
];

export const archProjects = [
  {
    title: "House",
    subtitle: "House Design",
    description: "Private Residence",
    image:
      "https://i.pinimg.com/564x/80/e2/93/80e293b144175738141db62be2ace589.jpg",
    link: "aromdi.com",
  },
  {
    title: "S43",
    subtitle: "Service Apartment Design",
    description: "Service Apartment Design",
    image:
      "https://i.pinimg.com/564x/86/d1/a1/86d1a1d738e42cc0335af71fe2d431ad.jpg",
    link: "https://Brownrice-uk.com",
  },
  {
    title: "Old Town Bangkok Hostel",
    subtitle: "Renovation Project",
    description: "Hostel in a center old Bangkok area",
    image:
      "https://i.pinimg.com/564x/d2/33/20/d23320c926908dab5337ffe65be37e2f.jpg",
    link: "aromdi.com",
  },
  {
    title: "Baan lae Suan (House and Garden Magazine)",
    subtitle: "Publication",
    description: "small house design for a design magazine",
    image:
      "https://i.pinimg.com/474x/8d/c8/5e/8dc85e40d8726ef75532cc4ff10c6a74.jpg",
    link: "https://Brownrice-uk.com",
  },
  {
    title: "Baan lae Suan (House and Garden Magazine)",
    subtitle: "Publication",
    description: "small house design for a design magazine",
    image:
      "https://i.pinimg.com/474x/8d/c8/5e/8dc85e40d8726ef75532cc4ff10c6a74.jpg",
    link: "https://Brownrice-uk.com",
  },

];

export const plays = [
  {
    title: "Sketch and Painting",
    subtitle: "Arts",
    description: "Sketch and watercolor painting of people and architecture",
    image:
      "https://i.pinimg.com/236x/0b/2a/b6/0b2ab648a43d285d1b6003ead3c42baa.jpg",
    link: "https://reactbootcamp.com",
  },
  {
    title: "Character Design and Digital Art",
    subtitle: "Illustrator",
    description: "character design of LINE sticker",
    image:
      "https://i.pinimg.com/236x/45/88/d9/4588d9af418e43774f46599d97d43787.jpg",
    link: "https://reactbootcamp.com",
  },
  {
    title: "all about musicd",
    subtitle: "Music",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image:
      "https://i.pinimg.com/236x/6d/14/c3/6d14c39d7438c5e01b0b7b42f8639b8e.jpg",
    link: "https://reactbootcamp.com",
  },
  {
    title: "Roblox Studio",
    subtitle: "Games",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image:
      "https://i.pinimg.com/564x/c9/e6/2d/c9e62dac702b7b08d1d8a711856b625f.jpg",
    link: "https://reactbootcamp.com",
  },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "Design Thinking",
  "Figma",
  "HTML CSS",
  "JavaScript",
  "React",
  "Adobe Creative Suites",
  "3D Model (SketchUP, Blender)",
  "3D Rendering (Lumion)",
  "AutoCAD",
  "Hand Sketch and Painting",
];

export const codingJourney = [
  {
    title: "Day1",
    description: "Javascript30 : javascript practice",
    image: "./project-4.gif",
    link: "https://reactbootcamp.com",
  },
];

export const projectArch = [
  {
    name:"House for the extended family",
    type:"Private Residence Renovation",
    location:"Bangkok",
    src:"https://picsum.photos/200/300?random=1",
    alt:"",
    description:"A private resident renovation project for an extend family",
  },
  {
    name:"Boutique Hostel",
    type:"Hostel",
    location:"Old Town Bangkok",
    src:"https://picsum.photos/200/300?random=2",
    alt:"",
    description:"Renovation project of a boutique hostel converted from an old row house",
  },
  {
    name:"Extended Family House",
    type:"House",
    location:"Bangkok",
    src:"https://picsum.photos/200/300?random=3",
    alt:"",
    description:"A private resident renovation project for an extend family",
  },
  {
    name:"Extended Family House",
    type:"House",
    location:"Bangkok",
    src:"https://picsum.photos/200/300?random=4",
    alt:"",
    description:"A private resident renovation project for an extend family",
  },
  {
    name:"Extended Family House",
    type:"House",
    location:"Bangkok",
    src:"https://picsum.photos/200/300?random=3",
    alt:"",
  },
  {
    name:"Extended Family House",
    type:"House",
    location:"Bangkok",
    src:"https://picsum.photos/200/300?random=4",
    alt:"",
  },
  {
    name:"Extended Family House",
    type:"House",
    location:"Bangkok",
    src:"https://picsum.photos/200/300?random=3",
    alt:"",
  },
  {
    name:"Extended Family House",
    type:"House",
    location:"Bangkok",
    src:"https://picsum.photos/200/300?random=4",
    alt:"",
  },
];

export const painting = [
  {
    src: "https://scontent.fbkk29-7.fna.fbcdn.net/v/t1.6435-9/53930152_10157134358459222_295173620282425344_n.jpg?_nc_cat=106&ccb=1-7&_nc_sid=0debeb&_nc_eui2=AeHZHeODN3veTuQKpm0r5rEoED8REHtgsZ8QPxEQe2Cxn2shuQFqPV6UAnjT7gviofg&_nc_ohc=LxDYM3_vRx8AX_y_4i8&_nc_ht=scontent.fbkk29-7.fna&oh=00_AfCQJ5kZIxaPao2EimGZxli-j3SVxtrHG7reSQ4ecFy3ew&oe=641EE617",
    alt: "NatTK-Painting-Nepal",
  },
  {
    src: "https://scontent.fbkk29-4.fna.fbcdn.net/v/t1.6435-9/53599070_10157134358489222_5764449524072316928_n.jpg?_nc_cat=110&ccb=1-7&_nc_sid=0debeb&_nc_eui2=AeEMk9rsPJrJeILUr9Ub0gTgzccNnpu_AOXNxw2em78A5ZvV5FOnmV9aCWY0poeJFhA&_nc_ohc=JPJaekNeyHwAX_7NfQi&_nc_ht=scontent.fbkk29-4.fna&oh=00_AfCjPvufGLBHCkWAkxEoFIDGq-cOQzuNgmM0UJUCCACEkQ&oe=641EDDC5",
    alt: "NatTK-Painting-House at Catherine Street",
  },
  {
    src: "https://scontent.fbkk29-5.fna.fbcdn.net/v/t1.6435-9/54428326_10157134358664222_5438222237972824064_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=0debeb&_nc_eui2=AeHT3tvbytGDCwxQ4nuNnmXHLH19eW37II8sfX15bfsgj27yiS2tJTOrOgXXxrgVLSI&_nc_ohc=bwZD6FX2vuEAX9IPsyN&_nc_ht=scontent.fbkk29-5.fna&oh=00_AfBz79HrAw_hyYAbOQGLTBt7Bt8WE1Zail_DqWby6_mU7Q&oe=641EFE3E",
    alt: "NatTK-Painting-A Boat",
  },
  {
    src: "https://scontent.fbkk29-4.fna.fbcdn.net/v/t1.6435-9/53799319_10157134358754222_8719645451902517248_n.jpg?_nc_cat=110&ccb=1-7&_nc_sid=0debeb&_nc_eui2=AeF--_OpWpDVIqBbpY4lteNi59lDMC_VZivn2UMwL9VmK28xwZTif3C0PtShDRI5zVo&_nc_ohc=-LQolsCQnfcAX9Z_3P4&_nc_ht=scontent.fbkk29-4.fna&oh=00_AfC5C4lGx_606Xy0MQCRlmNOd4FE6B1o8CMLcMlRy5HUkw&oe=641EE823",
    alt: "NatTK-Painting-Lavender_field",
  },
  {
    src: "https://scontent.fbkk29-9.fna.fbcdn.net/v/t1.6435-9/54257926_10157134358819222_4180747060284227584_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=0debeb&_nc_eui2=AeF01-QuMn632l0HUm3xjyPsAdb683GE7a4B1vrzcYTtrolK9OV_bNd72cVy7_ll8hk&_nc_ohc=9pNaKHdLCCIAX-pRGm1&tn=bnQPPPp6fwWiOego&_nc_ht=scontent.fbkk29-9.fna&oh=00_AfDJL0BcbwY3TBd94GiZO2zqlyezf36G5ZTJqIj-4YyINg&oe=641EE3D6",
    alt: "NatTK-Painting-A house",
  },
  {
    src: "https://scontent.fbkk29-8.fna.fbcdn.net/v/t1.6435-9/53632164_10157134358854222_3185418845049323520_n.jpg?_nc_cat=102&ccb=1-7&_nc_sid=0debeb&_nc_eui2=AeFdyLzJJ0UYeB1QPuxovGRV-2URi6rYikf7ZRGLqtiKR1Oh7Fdzvw6TbZ0uzSvWHPc&_nc_ohc=CNEd6-X6JUcAX-L05-h&_nc_ht=scontent.fbkk29-8.fna&oh=00_AfDsYUXfyFqAW0gNKmmZXZXXb-6e2JhdXJsvq1dHNpWO_g&oe=641F1A75",
    alt: "NatTK-Painting-Boats",
  },
];

export const hundredDays = [
  {
    day: "1",
    src: "https://pbs.twimg.com/media/FhLLizYakAA5QGz?format=jpg&name=medium",
    alt: "Drums Machine",
    topic: "Drums Machine",
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/Javascript30/blob/main/Day01-jsDrumsKit/index.html",
    codelink:
      "https://github.com/tk0779/Javascript30/tree/main/Day01-jsDrumsKit",
    learn: "#javascript",
    date: "Nov 10, 2022",
  },
  {
    day: "2",
    src: "https://pbs.twimg.com/media/FhQ02dbaUAUySSz?format=jpg&name=900x900",
    alt: "JS Clock",
    topic: "JS Clock",
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/Javascript30/blob/main/Day2JsCssClock/index.html",
    codelink: "https://github.com/tk0779/Javascript30/tree/main/Day2JsCssClock",
    learn: "#javascript",
    date: "Nov 11, 2022",
  },
  {
    day: "3",
    src: "https://pbs.twimg.com/media/FhXivJXVQAADXV3?format=jpg&name=medium",
    alt: "Update CSS with Javascript",
    topic: "Update CSS with Javascript",
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/Javascript30/blob/main/Day03-updateCSSvariablewithJS/index.html",
    codelink:
      "https://github.com/tk0779/Javascript30/tree/main/Day03-updateCSSvariablewithJS",
    learn: "#javascript",
    date: "Nov 12, 2022",
  },
  {
    day: "4",
    src: "https://pbs.twimg.com/media/FhbW7ycaEAAD9dd?format=jpg&name=900x900",
    alt: `Learn to use .filter() , .map() ,.sort() ,.reduce()`,
    topic: `Learn to use .filter() , .map() ,.sort() ,.reduce()`,
    desc: "",
    projectlink:
      "https://github.com/tk0779/Javascript30/blob/main/Day04-ArrayExercise/index.html",
    codelink:
      "https://github.com/tk0779/Javascript30/tree/main/Day04-ArrayExercise",
    learn: "#javascript",
    date: "Nov 13, 2022",
  },
  {
    day: "5",
    src: "https://res.cloudinary.com/dxj2cymt8/image/upload/v1677316883/tk0779githubio/day05_mu8drp.png",
    alt: `Flex Panel`,
    topic: `Flex Panel`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/Javascript30/blob/main/Day05-FlexPanels/index.html",
    codelink:
      "https://github.com/tk0779/Javascript30/tree/main/Day05-FlexPanels",
    learn: "#javascript",
    date: "Nov 14, 2022",
  },
  {
    day: "6",
    src: "https://pbs.twimg.com/media/FhnHEWzaYAMy4t7?format=jpg&name=small",
    alt: `"Type Ahead Searchbox"`,
    topic: `"Type Ahead Searchbox"`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/Javascript30/blob/main/Day06-Type/index.html",
    codelink: "https://github.com/tk0779/Javascript30/tree/main/Day06-Type",
    learn: "#javascript",
    date: "Nov 15, 2022",
  },
  {
    day: "7",
    src: "https://pbs.twimg.com/media/FhqQ9QgagAMjNLB?format=jpg&name=medium",
    alt: `learn to use .some, .every, .find , .findIndex`,
    topic: `learn to use .some, .every, .find , .findIndex`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/Javascript30/blob/main/Day07%20-%20ArrayCardio2/index.html",
    codelink:
      "https://github.com/tk0779/Javascript30/tree/main/Day07%20-%20ArrayCardio2",
    learn: "#javascript",
    date: "Nov 16, 2022",
  },
  {
    day: "8",
    src: "https://res.cloudinary.com/dxj2cymt8/image/upload/v1677316883/tk0779githubio/day08_xopxct.png",
    alt: `HTML5 Canvas`,
    topic: `HTML5 Canvas`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/Javascript30/blob/main/Day08%20-%20HTML5%20Canvas/index.html",
    codelink:
      "https://github.com/tk0779/Javascript30/tree/main/Day08%20-%20HTML5%20Canvas",
    learn: "#javascript",
    date: "Nov 17, 2022",
  },
  {
    day: "9 Round 1",
    src: "https://pbs.twimg.com/media/Fh1KJtvacAAZzMH?format=jpg&name=900x900",
    alt: `Console Trick`,
    topic: `Console Trick`,
    desc: "",
    projectlink:
      "https://github.com/tk0779/Javascript30/tree/main/Day09%20-%20Console%20Tricks",
    codelink:
      "https://github.com/tk0779/Javascript30/tree/main/Day09%20-%20Console%20Tricks",
    learn: "#javascript",
    date: "Nov 18, 2022",
  },
  {
    day: "9 Round 2",
    src: "https://res.cloudinary.com/dxj2cymt8/image/upload/v1677316884/tk0779githubio/day09_owhs7w.png",
    alt: `Memory Game`,
    topic: `Memory Game`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/Javascript30/blob/main/Day09-R2-MemoryGame/index.html",
    codelink:
      "https://github.com/tk0779/Javascript30/tree/main/Day09-R2-MemoryGame",
    learn: "#javascript",
    date: "Nov 18, 2022",
  },
  {
    day: "10",
    src: "https://pbs.twimg.com/media/Fh7DSQ0agAAMGZj?format=jpg&name=900x900",
    alt: `Hold shift to select multiple`,
    topic: `Hold shift to select multiple`,
    desc: "",
    projectlink:
      "https://twitter.com/search?q=100daysofcode%20(from%3Atk0779)&src=typed_query&f=live",
    codelink:
      "https://github.com/tk0779/Javascript30/tree/main/Day10-shifttoaddmultiple",
    learn: "#javascript",
    date: "Nov 19, 2022",
  },
  {
    day: "11",
    src: "https://res.cloudinary.com/dxj2cymt8/image/upload/v1677316885/tk0779githubio/day11_gbh2mn.png",
    alt: `VDO Player`,
    topic: `VDO Player`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/Javascript30/blob/main/Day11-HTMLVDOplayer/index.html",
    codelink:
      "https://github.com/tk0779/Javascript30/tree/main/Day11-HTMLVDOplayer",
    learn: "#javascript",
    date: "Nov 20, 2022",
  },
  {
    day: "12",
    src: "https://res.cloudinary.com/dxj2cymt8/image/upload/v1677316884/tk0779githubio/day12_hybufb.png",
    alt: `Sprite Animation`,
    topic: `Sprite Animation`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/day12-jssprite/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/day12-jssprite",
    learn: "#javascript",
    date: "Nov 21, 2022",
  },
  {
    day: "13",
    src: "https://pbs.twimg.com/media/FiK3qXcagAA42sQ?format=jpg&name=medium",
    alt: `Todo App`,
    topic: `Todo App`,
    desc: "",
    projectlink:
      "https://pbs.twimg.com/media/FiK3qXcagAA42sQ?format=jpg&name=medium",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/day13-react-todoapp",
    learn: "#javascript #react",
    date: "Nov 22, 2022",
  },
  {
    day: "14",
    src: "https://pbs.twimg.com/media/FiQlJB7aAAAfjSI?format=png&name=small",
    alt: `slide in image when scroll`,
    topic: `slide in image when scroll`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/day14-slideimagewhenscroll/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/day14-slideimagewhenscroll",
    learn: "#javascript",
    date: "Nov 23, 2022",
  },
  {
    day: "15",
    src: "https://res.cloudinary.com/dxj2cymt8/image/upload/v1677316884/tk0779githubio/day15_r3ttev.png",
    alt: `Color Flipper`,
    topic: `Color Flipper`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://raw.githubusercontent.com/tk0779/100daysofcode/main/day15%20-%20colorflipper/hex.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/day15%20-%20colorflipper",
    learn: "#javascript",
    date: "Nov 24, 2022",
  },
  {
    day: "15 Round 2",
    src: "https://pbs.twimg.com/media/FiUtSjiakAAgpoX?format=png&name=small",
    alt: `JS Reference`,
    topic: `JS Reference`,
    desc: "",
    projectlink:
      "https://pbs.twimg.com/media/FiUtSjiakAAgpoX?format=png&name=small",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/day15r2-JS%20reference",
    learn: "#javascript",
    date: "Nov 24, 2022",
  },
  {
    day: "16",
    src: "https://pbs.twimg.com/media/FibE-IraEAUzhRN?format=png&name=small",
    alt: `JS Counter`,
    topic: `JS Counter`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/day16%20-%20JS%20counter/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/day16%20-%20JS%20counter",
    learn: "#javascript",
    date: "Nov 25, 2022",
  },
  {
    day: "17",
    src: "https://pbs.twimg.com/media/FigDPkUaEAA6A8J?format=png&name=small",
    alt: `Review Box`,
    topic: `Review Box`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/day17%20-%20jsReviewBox/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/day17%20-%20jsReviewBox",
    learn: "#javascript",
    date: "Nov 26, 2022",
  },
  {
    day: "18",
    src: "https://pbs.twimg.com/media/Fik6RMbagAAlALe?format=png&name=small",
    alt: `Navbar`,
    topic: `Navbar`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/day18%20-%20navbar/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/day18%20-%20navbar",
    learn: "#javascript",
    date: "Nov 27, 2022",
  },
  {
    day: "19",
    src: "https://pbs.twimg.com/media/FiqiTkUacAEaUZw?format=jpg&name=medium",
    alt: `Portfolio Responsive Website`,
    topic: `Portfolio Responsive Website`,
    desc: "(no link)",
    projectlink: "/",
    codelink: "/",
    learn: "#javascript",
    date: "Nov 28, 2022",
  },
  {
    day: "20",
    src: "https://pbs.twimg.com/media/FivoDvpagAEGN6b?format=png&name=medium",
    alt: `Question and answer`,
    topic: `Question and answer`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/day20%20-%20JSquestionbox/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/day20%20-%20JSquestionbox",
    learn: "#javascript",
    date: "Nov 29, 2022",
  },
  {
    day: "21",
    src: "https://res.cloudinary.com/dxj2cymt8/image/upload/v1677316885/tk0779githubio/day21_agbuhx.png",
    alt: `Mouse Shadow`,
    topic: `Mouse Shadow`,
    desc: "",
    projectlink:
      "https://hhttps://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/day21-%20mouseShadow/index.htmltmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/day20%20-%20JSquestionbox/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/day21-%20mouseShadow",
    learn: "#javascript",
    date: "Nov 30, 2022",
  },
  {
    day: "22",
    src: "https://pbs.twimg.com/media/Fi6H-byaMAEGsTp?format=png&name=small",
    alt: ` tally string with reduce (total VDO time)`,
    topic: ` tally string with reduce (total VDO time)`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/Day22%20-%20total%20VDO%20time/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/Day22%20-%20total%20VDO%20time",
    learn: "#javascript",
    date: "Dec 2, 2022",
  },
  {
    day: "23",
    src: "https://pbs.twimg.com/media/Fi8qKrJaMAEeSZG?format=jpg&name=small",
    alt: `learn FB clone API tutorial`,
    topic: `learn FB clone API tutorial`,
    desc: "no link",
    projectlink: "",
    codelink: "",
    learn: "#javascript",
    date: "Dec 2, 2022",
  },
  {
    day: "24",
    src: "https://pbs.twimg.com/media/FjEZbEHaMAAW_DX?format=png&name=small",
    alt: `Sorting Band Names without articles`,
    topic: `Sorting Band Names without articles`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/Day24-Sorting%20Band%20Names%20without%20articles/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/Day24-Sorting%20Band%20Names%20without%20articles",
    learn: "#javascript",
    date: "Dec 4, 2022",
  },
  {
    day: "25",
    src: "https://pbs.twimg.com/media/FjJQgqkaAAAH2nP?format=jpg&name=small",
    alt: `working on my portfolio slider part`,
    topic: `working on my portfolio slider part`,
    desc: "(no link)",
    projectlink: "",
    codelink: "",
    learn: "#javascript",
    date: "Dec 4, 2022",
  },
  {
    day: "26",
    src: "https://pbs.twimg.com/media/FjNw_FpagAA7mLP?format=png&name=small",
    alt: `automatic slideshow`,
    topic: `automatic slideshow`,
    desc: "(no link)",
    projectlink: "",
    codelink: "",
    learn: "#javascript",
    date: "Dec 5, 2022",
  },
  {
    day: "27",
    src: "https://pbs.twimg.com/media/FjT7KC3aUAALIHo?format=png&name=small",
    alt: ` speech recognition`,
    topic: ` speech recognition`,
    desc: "(no link)",
    projectlink: "",
    codelink: "",
    learn: "#javascript",
    date: "Dec 7, 2022",
  },
  {
    day: "28",
    src: "https://pbs.twimg.com/media/FjY8r5EaAAAXu8h?format=jpg&name=360x360",
    alt: `Responsive photo gallery CSS`,
    topic: `Responsive photo gallery CSS`,
    desc: "(no link)",
    projectlink: "",
    codelink: "",
    learn: "#javascript",
    date: "Dec 7, 2022",
  },
  {
    day: "29",
    src: "https://res.cloudinary.com/dxj2cymt8/image/upload/v1677316885/tk0779githubio/day29_gy6uhi.png",
    alt: `Speech Recognition`,
    topic: `Speech Recognition`,
    desc: "",
    projectlink:
      "https://github.com/tk0779/100daysofcode/blob/main/Day29-speechRecognition/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/Day29-speechRecognition",
    learn: "#javascript",
    date: "Dec 8, 2022",
  },
  {
    day: "30",
    src: "https://pbs.twimg.com/media/FjjuCHtaMAE7O2_?format=png&name=small",
    alt: `Sticky Nav`,
    topic: `Sticky Nav`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/Day30-stickyNav/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/Day30-stickyNav",
    learn: "#javascript",
    date: "Dec 10, 2022",
  },
  {
    day: "31",
    src: "https://res.cloudinary.com/dxj2cymt8/image/upload/v1677316886/tk0779githubio/day31_q0f7mo.png",
    alt: `Follow along link`,
    topic: `Follow along link`,
    desc: "(no link)",
    projectlink: "",
    codelink: "",
    learn: "#javascript",
    date: "Dec 10, 2022",
  },
  {
    day: "32",
    src: "https://pbs.twimg.com/media/Fjtz510aMAAT1Ud?format=jpg&name=small",
    alt: `learn to make an app using html/css/js in Android Studio`,
    topic: `learn to make an app using html/css/js in Android Studio`,
    desc: "(no link)",
    projectlink: "",
    codelink: "",
    learn: "#javascript",
    date: "Dec 12, 2022",
  },
  {
    day: "33",
    src: "https://pbs.twimg.com/media/Fjyba6aagAYXpFh?format=png&name=small",
    alt: `Text to speech tutorial`,
    topic: `Text to speech tutorial`,
    desc: "",
    projectlink:
      "https://rawcdn.githack.com/tk0779/100daysofcode/37804c2e0c445574f1b886d8724aee1d25bbab8c/day33%20-%20texttoSpeech/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/day33%20-%20texttoSpeech",
    learn: "#javascript",
    date: "Dec 12, 2022",
  },
  {
    day: "34",
    src: "https://res.cloudinary.com/dxj2cymt8/image/upload/v1677316887/tk0779githubio/day34_ik5hsp.png",
    alt: `Whack-a-mole game`,
    topic: `Whack-a-mole game`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/day34-whack-a-mole/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/day34-whack-a-mole",
    learn: "#javascript",
    date: "Dec 13, 2022",
  },
  {
    day: "35",
    src: "https://pbs.twimg.com/media/Fj8010laMAAXKhd?format=png&name=small",
    alt: `Digital CLock`,
    topic: `Digital CLock`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/day35%20-%20js%20digital%20clock/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/day35%20-%20js%20digital%20clock",
    learn: "#javascript",
    date: "Dec 14, 2022",
  },
  {
    day: "36",
    src: "https://pbs.twimg.com/media/FkEcMTcaMAAW5YI?format=jpg&name=small",
    alt: `facebook clone tutorial`,
    topic: `facebook clone tutorial`,
    desc: "(no link)",
    projectlink: "",
    codelink: "",
    learn: "#javascript #react",
    date: "Dec 16, 2022",
  },
  {
    day: "37",
    src: "https://pbs.twimg.com/media/FkLzq4YaMAAI-tD?format=jpg&name=small",
    alt: `Facebook clone tutorial front end`,
    topic: `Facebook clone tutorial front end`,
    desc: "(no link)",
    projectlink: "",
    codelink: "",
    learn: "#javascript #react",
    date: "Dec 17, 2022",
  },
  {
    day: "38",
    src: "https://pbs.twimg.com/media/FkMBp_1aYAAZKdz?format=jpg&name=small",
    alt: `Facebook clone tutorial -login`,
    topic: `Facebook clone tutorial -login`,
    projectlink: "",
    codelink: "",
    learn: "#javascript #react",
    date: "Dec 18, 2022",
  },
  {
    day: "39",
    src: "https://pbs.twimg.com/media/FkMA6_NagAESc1b?format=jpg&name=360x360",
    alt: `Facebook clone tutorial -Modal`,
    topic: `Facebook clone tutorial -Modal`,
    desc: "(no link)",
    projectlink: "",
    codelink: "",
    learn: "#javascript #react",
    date: "Dec 18, 2022",
  },
  {
    day: "40",
    src: "https://pbs.twimg.com/media/FkWzez7UEAE31N7?format=jpg&name=small",
    alt: `Facebook clone tutorial -Register`,
    topic: `Facebook clone tutorial -Register`,
    desc: "(no link)",
    projectlink: "",
    codelink: "",
    learn: "#javascript #react",
    date: "Dec 20, 2022",
  },
  {
    day: "41",
    src: "https://pbs.twimg.com/media/Fkb4tO5acAEZzIx?format=jpg&name=360x360",
    alt: `Facebook clone tutorial -Register`,
    topic: `Facebook clone tutorial -Register`,
    desc: "React hook binding state (no link)",
    projectlink: "",
    codelink: "",
    learn: "#javascript #react",
    date: "Dec 20, 2022",
  },
  {
    day: "42",
    src: "https://pbs.twimg.com/media/Fkg1vUZakAMMUdC?format=jpg&name=360x360",
    alt: `Facebook clone tutorial -Register`,
    topic: `Facebook clone tutorial -Register`,
    desc: "tutorial- register part - write validation using #joi library and toastify and create send request via axios (no link)",
    projectlink: "",
    codelink: "",
    learn: "#javascript #react",
    date: "Dec 21, 2022",
  },
  {
    day: "43",
    src: "https://pbs.twimg.com/media/FkwAtz5aEAAelbU?format=jpg&name=small",
    alt: `connect four game`,
    topic: `connect four game`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/day%2043%20-%20connect-four-jsgame/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/day%2043%20-%20connect-four-jsgame",
    learn: "#javascript ",
    date: "Dec 24, 2022",
  },
  {
    day: "44",
    src: "https://pbs.twimg.com/media/FkwGGukaYAAfvyY?format=jpg&name=small",
    alt: `learning flex direction tutorial`,
    topic: `learning flex direction tutorial`,
    desc: "(no link)",
    projectlink: "",
    codelink: "",
    learn: "#javascript ",
    date: "Dec 24, 2022",
  },
  {
    day: "45",
    src: "https://pbs.twimg.com/media/FkwH_U5aMAAfA2x?format=jpg&name=small",
    alt: `Nokia snake game`,
    topic: `Nokia snake game`,
    desc: "React hook binding state (no link)",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/Day%2045%20-%20nokia-snake-game/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/Day%2045%20-%20nokia-snake-game",
    learn: "#javascript #react",
    date: "Dec 24, 2022",
  },
  {
    day: "46",
    src: "https://pbs.twimg.com/media/Fkb4tO5acAEZzIx?format=jpg&name=360x360",
    alt: `make tab using Javascript`,
    topic: `make tab using Javascript`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/day46-tab/index.html",
    codelink: "",
    learn: "#javascript ",
    date: "Jan 1, 2023",
  },
  {
    day: "46 Round 2",
    src: "https://pbs.twimg.com/media/FlZDs_sacAwXrUu?format=jpg&name=small",
    alt: `Countdown timer`,
    topic: `Countdown timer`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/Day46R2/index.html",
    codelink: "https://github.com/tk0779/100daysofcode/tree/main/Day46R2",
    learn: "#javascript ",
    date: "Jan 1, 2023",
  },
  {
    day: "47",
    src: "https://pbs.twimg.com/media/Fld9_CmakAAqIB9?format=jpg&name=small",
    alt: `Lorem Ipsum generator using javascript`,
    topic: `Lorem Ipsum generator using javascript`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/day47r1-LoremIpsumGenerator/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/day47r1-LoremIpsumGenerator",
    learn: "#javascript ",
    date: "Jan 2, 2023",
  },
  {
    day: "47 Round 2",
    src: "https://pbs.twimg.com/media/FleBetfaMAAAWRb?format=png&name=small",
    alt: `Shopping List`,
    topic: `Shopping List`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/day47r2-shoppingList/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/day47r2-shoppingList",
    learn: "#javascript ",
    date: "Jan 2, 2023",
  },
  {
    day: "48",
    src: "https://res.cloudinary.com/dxj2cymt8/image/upload/v1677316885/tk0779githubio/day48_emgdho.png",
    alt: `JS slider`,
    topic: `JS slider`,
    desc: "",
    projectlink:
      "https://github.com/tk0779/100daysofcode/tree/main/day48r1-slide",
    codelink: "https://github.com/tk0779/100daysofcode/tree/main/day48r1-slide",
    learn: "#javascript ",
    date: "Jan 3, 2022",
  },
  {
    day: "48 Round 2",
    src: "https://res.cloudinary.com/dxj2cymt8/image/upload/v1677316886/tk0779githubio/day48r2_xva5oj.png",
    alt: `JS modal`,
    topic: `JS modal`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/day48r2-modal/index.html",
    codelink: "https://github.com/tk0779/100daysofcode/tree/main/day48r2-modal",
    learn: "#javascript ",
    date: "Jan 3, 2022",
  },
  {
    day: "49",
    src: "https://pbs.twimg.com/media/Flo5_5VaYAEG_GV?format=jpg&name=small",
    alt: `Learn CSS wrap`,
    topic: `Learn CSS wrap`,
    desc: "(no link)",
    projectlink: "",
    codelink: "",
    learn: "#javascript",
    date: "Jan 4, 2022",
  },
  {
    day: "49 Round 2",
    src: "https://pbs.twimg.com/media/Flo-1OYaUAI85-x?format=jpg&name=small",
    alt: ` Menu Sorting`,
    topic: ` Menu Sorting`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/Day49R2-Menu/index.html",
    codelink: "https://github.com/tk0779/100daysofcode/tree/main/Day49R2-Menu",
    learn: "#javascript",
    date: "Jan 4, 2022",
  },
  {
    day: "50",
    src: "https://pbs.twimg.com/media/Flth7I9aUAYEjWr?format=png&name=small",
    alt: `Rock Paper Scissor Game`,
    topic: `Rock Paper Scissor Game`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/day50r1-rockpaperscissor/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/day50r1-rockpaperscissor",
    learn: "#javascript ",
    date: "Jan 5, 2022",
  },
  {
    day: "50 Round 2",
    src: "https://pbs.twimg.com/media/FltpBhXaUAMN6YD?format=png&name=small",
    alt: `Breakout game`,
    topic: `Breakout game`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/day50r20breakoutgame/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/day50r20breakoutgame",
    learn: "#javascript ",
    date: "Jan 5, 2022",
  },
  {
    day: "51",
    src: "https://pbs.twimg.com/media/FlzOgrAaMAEJGmt?format=png&name=small",
    alt: `Space Invader Game`,
    topic: `Space Invader Game`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/day51r1-spacegame/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/day51r1-spacegame",
    learn: "#javascript ",
    date: "Jan 6, 2022",
  },
  {
    day: "51 Round 2",
    src: "https://res.cloudinary.com/dxj2cymt8/image/upload/v1677316887/tk0779githubio/day51r2_ylf7hj.png",
    alt: `Create a simple website`,
    topic: `Create a simple website`,
    desc: "",
    projectlink: "",
    codelink: "",
    learn: "#javascript ",
    date: "Jan 6, 2022",
  },
  {
    day: "52",
    src: "https://res.cloudinary.com/dxj2cymt8/image/upload/v1677316886/tk0779githubio/day52_wzv4u7.png",
    alt: `Countdown to New Year 2024`,
    topic: `Countdown to New Year 2024`,
    desc: "",
    projectlink: "Countdown to New Year 2024",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/day52r1-countdownToNewYear",
    learn: "#javascript ",
    date: "Jan 6, 2022",
  },
  {
    day: "52 Round 2",
    src: "https://pbs.twimg.com/media/Fl4OjbEaEAAYxkQ?format=jpg&name=medium",
    alt: `quiz app`,
    topic: `quiz app`,
    desc: "",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/Day52R2-quizApp/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/Day52R2-quizApp",
    learn: "#javascript ",
    date: "Jan 6, 2022",
  },
  {
    day: "53",
    src: "https://res.cloudinary.com/dxj2cymt8/image/upload/v1677316888/tk0779githubio/day53_bkmnn1.png",
    alt: `Asynshronous`,
    topic: `Asynshronous`,
    desc: "learn JS Asynshronous from this very good clip. Joy Shaheb explains it very clear using a tangible example.",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/Day52R2-quizApp/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/Day52R2-quizApp",
    learn: "#javascript ",
    date: "Jan 6, 2022",
  },
];

export const ArchitectProject = [
  {
    day: "53",
    src: "https://res.cloudinary.com/dxj2cymt8/image/upload/v1677316888/tk0779githubio/day53_bkmnn1.png",
    alt: `Asynshronous`,
    topic: `Asynshronous`,
    desc: "learn JS Asynshronous from this very good clip. Joy Shaheb explains it very clear using a tangible example.",
    projectlink:
      "https://htmlpreview.github.io/?https://github.com/tk0779/100daysofcode/blob/main/Day52R2-quizApp/index.html",
    codelink:
      "https://github.com/tk0779/100daysofcode/tree/main/Day52R2-quizApp",
    learn: "#javascript ",
    date: "Jan 6, 2022",
  },
]

export const frontendDev = [
  {
    title:"personal portfolio react project",
    src:"https://picsum.photos/200/300?random=1",
    alt:"",
    desc:"react project that use librry to enhance performance and image of the website"
  },
  {
    title:"personal portfolio react project",
    src:"https://picsum.photos/200/300?random=2",
    alt:"",
    desc:"react project that use librry to enhance performance and image of the website"
  },
  {
    title:"personal portfolio react project",
    src:"https://picsum.photos/200/300?random=3",
    alt:"",
    desc:"react project that use librry to enhance performance and image of the website"
  },
]